export { default as IndexTableCellIcon } from './IndexTableCellIcon';
